import {styled, Typography} from '@mui/material';

export const TalkingPointLabel = styled(Typography)(({theme}) => ({
  fontSize: theme.typography.pxToRem(14),
  fontWeight: '500',
  fontStyle: 'oblique',
  color: '#4D5562',
}));
